// const contractReposition = function
function contractReposition(UserInfo, Alert){
    return {
        restrict: 'AE',
        templateUrl: require('../../templates/contract-detail-reposition.html'),
        controller: function ($scope, $http, $rootScope, $filter, $routeParams, ContractDetail) {
            /***********************************************************************************************************
            * Controller Attributes
            ***********************************************************************************************************/
            var $translate = $filter('translate');
            var self = this;

            /***********************************************************************************************************
            * Scope Attributes
            ***********************************************************************************************************/
            $scope.id = $routeParams.id;
            $scope.flagReposition = false;
            $scope.reposition_type = '';

            $scope.hasPerm = UserInfo.hasPerm('contracts.change_contract');

            $scope.repositionTypes = {
                "01": 'Reposición por contratación o cambio indebido solicitada por el comercializador entrante',
                "02": 'Reposición por error administrativo solicitada por el comercializador entrante',
                "03": 'Reposición solicitada por el comercializador saliente'
            };

            /***********************************************************************************************************
            * Scope Watchers
            ***********************************************************************************************************/

            /***********************************************************************************************************
            * Controller Methods
            ***********************************************************************************************************/
            function performRequest() {
                var element = {
                    id: $scope.id,
                    reposition_contract: true,
                    reposition_type : $scope.reposition_type
                };

                ContractDetail.repositionContract(element)
                    .then(function (contract) {
                        Alert.createAlert('success', $translate('CONTRACTS.EVENT_REPOSITION_CREATED_FOR_CONTRACT'), true);
                    }).catch(function (error) {
                        console.log('ERROR', error)
                        for(var k in error){
                            $scope.error_message = error[k];
                            if (k === 'non_field_errors') {
                                $scope.error_message = error[k][0];
                                Alert.createAlert('danger', $scope.error_message, true);
                            }
                        }
                    }).finally(function () {
                        $scope.flagReposition = false;
                        $scope.reposition_type = '';
                    });
            }

            /***********************************************************************************************************
            * Scope Methods
            ***********************************************************************************************************/
            $scope.clickRepositionYes = function () {
                performRequest();
            };

            $scope.confirmReposition = function () {
                $scope.flagReposition = true;
            };

            $scope.clickRepositionNo = function () {
                $scope.flagReposition = false;
                $scope.reposition_type = '';
            };

        }
    }
}

export {contractReposition}
